import { getOneCmsApiUrl } from '../selectors/selectors';

export default {
  fetch: ({ type }, action, state) => ({
    url: `${getOneCmsApiUrl(state)}/Internet/travel/hub/${type}/alerts.json`,
    opts: {
      method: 'GET',
      credentials: 'omit',
    },
  }),
};
